import { render } from "./AlertComponent.vue?vue&type=template&id=caab1b7c"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__